// src/components/AppInitializer.jsx
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getCurrentUser } from '../services/actions/userActions'
import {
	setAuthUser,
	setOrgMemberships,
	setCurrentOrg,
	setCurrentExperience,
} from '../services/store/userSlice'

const AppInitializer = () => {
	const dispatch = useDispatch()

	useEffect(() => {
		const init = async () => {
			try {
				const user = await getCurrentUser()

				dispatch(
					setAuthUser({ id: user.id, name: user.name, email: user.email })
				)
				dispatch(setOrgMemberships(user.orgMemberships || []))
				dispatch(
					setCurrentOrg({
						orgId: user.orgId,
						orgSlug: user.orgSlug,
						orgRole: user.orgRole,
						orgName: user.orgName,
					})
				)

				if (user.currentExperience) {
					dispatch(setCurrentExperience(user.currentExperience))
				}
			} catch (err) {
				console.error('❌ Failed to initialize app:', err)
			}
		}

		init()
	}, [dispatch])

	return null
}

export default AppInitializer
